import { Icon } from 'types/Icon';

export const Icon24SunLow = ({ ...restProps }: Icon) => (
  <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" {...restProps}>
    <path fillRule="evenodd" clipRule="evenodd"
      d="M12 15.45c1.9054 0 3.45-1.5446 3.45-3.45 0-1.9054-1.5446-3.45-3.45-3.45-1.9054 0-3.45 1.5446-3.45 3.45 0 1.9054 1.5446 3.45 3.45 3.45Zm0 1.8c2.8995 0 5.25-2.3505 5.25-5.25 0-2.89949-2.3505-5.25-5.25-5.25-2.89949 0-5.25 2.35051-5.25 5.25 0 2.8995 2.35051 5.25 5.25 5.25Z"
      fill="currentColor" />
    <circle cx="18.5" cy="5.5" r="1" fill="currentColor" />
    <circle cx="5.5" cy="5.5" r="1" fill="currentColor" />
    <circle cx="20.5" cy="12" r="1" fill="currentColor" />
    <circle cx="3.5" cy="12" r="1" fill="currentColor" />
    <circle cx="18.5" cy="18.5" r="1" fill="currentColor" />
    <path d="M13 20.5c0 .5523-.4477 1-1 1s-1-.4477-1-1 .4477-1 1-1 1 .4477 1 1Z" fill="currentColor" />
    <circle cx="5.5" cy="18.5" r="1" fill="currentColor" />
    <path d="M13 3.5c0 .55228-.4477 1-1 1s-1-.44772-1-1 .4477-1 1-1 1 .44772 1 1Z" fill="currentColor" />
  </svg>
);
